<template>
  <keep-alive v-if="parameterComponent">
    <component :is="parameterComponent" :kind="kind" :disabled="isFinished" />
  </keep-alive>
  <div v-else>parameter not found</div>
</template>

<script>
import { PropsDefinition, Computed } from '@/_typedefs'
import ActParameterVue from './Act/ActParameter.vue'
import GinaParameterVue from './Gina/GinaParameter.vue'
import DlqiParameterVue from './Dlqi/DlqiParameter.vue'
import AsthmaParameterNodeVue from '../../Asthma/Parameters/AsthmaParameterNode.vue'

import { createNamespacedHelpers } from 'vuex'
import AtopicDermatitisParameterNode from '@/components/NewAttendanceForm/AtopicDermatitis/Parameters/AtopicDermatitisParameterNode.vue'

const { mapGetters: newAttendanceFormGetters } = createNamespacedHelpers('newAttendanceForm')

/**
 * @typedef {Object} ParameterNodeProps
 * @property {string} kind
 */

export default {
  name: 'ParameterNode',
  /** @type {PropsDefinition<ParameterNodeProps>} */
  props: {
    kind: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'component',
    },
  },
  computed: {
    .../** @type {{isFinished: Computed<boolean>}} */ (newAttendanceFormGetters(['isFinished'])),
    /** @type {Computed<Component?>} */
    parameterComponent() {
      const [parameter, disease] = this.kind.split(':').reverse()

      const diseaseMap = {
        asthma: AsthmaParameterNodeVue,
        'atopic-dermatitis': AtopicDermatitisParameterNode,
      }

      if (disease) {
        return diseaseMap[disease] ?? null
      }

      const parameterMap = {
        act: ActParameterVue,
        gina: GinaParameterVue,
        dlqi: DlqiParameterVue,
      }
      return parameterMap[parameter] ?? null
    },
  },
}
</script>

<style></style>
